import { useQuery } from "@tanstack/react-query";
import { convexQuery } from "@convex-dev/react-query";
import { api } from "@constructionautomation/backend";
import type { Id } from "@constructionautomation/backend/convex/_generated/dataModel";
import { useLoggedMutation } from "@/hooks/use-action-log-session";

export function useScheduleOverrides(jobId: Id<"takeoffPilotJobs"> | undefined) {
  const { data, isPending } = useQuery(
    convexQuery(api.takeoffPilot.scheduleOverrides.listByJob, jobId ? { jobId } : "skip")
  );
  return { overrides: data ?? [], isPending };
}

export function useUpsertScheduleOverride() {
  return useLoggedMutation(api.takeoffPilot.scheduleOverrides.upsert);
}

export function useAddScheduleOverrideColumn() {
  return useLoggedMutation(api.takeoffPilot.scheduleOverrides.addColumn);
}

export function useRemoveScheduleOverrideCells() {
  return useLoggedMutation(api.takeoffPilot.scheduleOverrides.removeCells);
}

export function useResetScheduleOverride() {
  return useLoggedMutation(api.takeoffPilot.scheduleOverrides.resetByTag);
}

export function useResetAllScheduleOverrides() {
  return useLoggedMutation(api.takeoffPilot.scheduleOverrides.resetByJob);
}
